import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/patients/$patientId/_layout/questionnaire-responses/$qrId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/patients/$patientId/assessments/q/$instanceId",
      params: { patientId: params.patientId, instanceId: params.qrId },
      replace: true,
    });
  },
});
